import clsx from 'clsx';

interface TabProps {
    label: string;
    index: number;
    onClick: (index: number) => void;
    active: number;
}

export default function Tab({ label, index, active, onClick }: TabProps) {
    return (
        <button
            type="button"
            className={clsx(
                'btn-tab mr-4 flex-1 border-b-2 border-transparent py-2 uppercase sm:text-xl',
                {
                    'btn-tab-active': active === index,
                },
            )}
            onClick={() => onClick(index)}>
            {label}
        </button>
    );
}
